import React, { createContext, useContext } from 'react';
import { useIntl } from 'react-intl';
import { translate } from '@smovilgps/optimus-intl';
import { message } from 'antd-v6';

type ToastApi = {
	success: (intlKey: string, intlValues?: Record<string, any>, duration?: number) => void;
	error: (intlKey?: string, intlValues?: Record<string, any>, duration?: number) => void;
	info: (intlKey: string, intlValues?: Record<string, any>, duration?: number) => void;
	warning: (intlKey: string, intlValues?: Record<string, any>, duration?: number) => void;
	loading: (intlKey: string, intlValues?: Record<string, any>, duration?: number) => void;
};

const ToastContext = createContext<ToastApi | null>(null);

export const AppToastProvider = ({ children }: { children: React.ReactNode }) => {
	const intl = useIntl();
	const [messageApi, contextHolder] = message.useMessage();
	const defaultDuration = 3; // in seconds

	const api: ToastApi = {
		success: (intlKey, intlValues = {}, duration = defaultDuration) => {
			messageApi.success(intl.formatMessage(translate(intlKey), intlValues), duration);
		},
		error: (intlKey = 'commonError', intlValues = {}, duration = defaultDuration) => {
			messageApi.error(intl.formatMessage(translate(intlKey), intlValues), duration);
		},
		info: (intlKey, intlValues = {}, duration = defaultDuration) => {
			messageApi.info(intl.formatMessage(translate(intlKey), intlValues), duration);
		},
		warning: (intlKey, intlValues = {}, duration = defaultDuration) => {
			messageApi.warning(intl.formatMessage(translate(intlKey), intlValues), duration);
		},
		loading: (intlKey, intlValues = {}, duration = defaultDuration) => {
			messageApi.loading(intl.formatMessage(translate(intlKey), intlValues), duration);
		},
	};

	return (
		<ToastContext.Provider value={api}>
			{contextHolder}
			{children}
		</ToastContext.Provider>
	);
};

export const useAppToast = () => {
	const ctx = useContext(ToastContext);
	if (!ctx) throw new Error('useAppToast must be used inside AppToastProvider');
	return ctx;
};
